// extracted by mini-css-extract-plugin
export default {"next":"NextArrow-module--next--56b45","black":"NextArrow-module--black--67cfd"};